app.component("aiAgentView", {
    templateUrl: "app/src/js/components/aiAgent/aiAgent.html",
    controller: "aiAgentController",
    bindings: {
        navigatePrompt: "&",
    },
});

app.controller("aiAgentController", [
    "$scope",
    "$modal",
    "ElevenLabsAPI",
    "ELEVEN_LABS_AI_TOUR_1261",
    "Session",
    "$q",
    function ($scope, $modal, ElevenLabsAPI, ELEVEN_LABS_AI_TOUR_1261, Session, $q) {

        $scope.API = ElevenLabsAPI;
        $scope.availableVoices = [];
        $scope.availablePrompts = [];
        $scope.selection = {
            promptId: null
        };
        // An object, not a primitive: the input sits inside ng-if child scopes, and a primitive
        // ng-model there would write to the child and never reach triggerTestCall.
        $scope.testCall = { phoneNumber: Session.user.phoneNumber || Session.user.phone_number || "" };

        this.$onInit = function () {
            $scope.showEdit = false;
            $scope.agentObj = {
                agent_name: '',
            }
            fetchAgentList();
        };

        $scope.popoverDelete = {
            content: "Delete",
        };

        $scope.popoverEdit = {
            content: "Edit",
        };

        $scope.openDeleteModal = (item) => {
            $scope.buttons = [
                {
                    label: 'Cancel',
                    type: 'btn-default',
                    onClick: function () {
                        $scope.generalModal.hide();
                    }
                },
                {
                    label: 'Delete Agent',
                    type: 'btn-navy',
                    onClick: function () {
                        $scope.generalModal.hide();
                        deleteAgent(item, false);
                    }
                },
                {
                    label: 'Delete with Prompts',
                    type: 'btn-danger',
                    onClick: function () {
                        $scope.generalModal.hide();
                        deleteAgent(item, true);
                    }
                }
            ];

            $scope.title = "Delete AI Agent";
            $scope.content = "Are you sure you want to delete this AI agent? You can delete just the agent, or the agent and all its associated prompts.";

            $scope.generalModal = $modal({
                scope: $scope,
                templateUrl: "app/src/views/templates/modal.multi-choice-modal.tpl.html",
                show: true,
                backdrop: true,
                keyboard: false
            });
        };

        function showGenericErrorModal() {
            if ($scope.serverErrorModal) {
                $scope.serverErrorModal.hide();
            }
            $scope.serverErrorModal = $modal({
                scope: $scope,
                templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
                show: true,
                title: "CatTrax has encountered an error",
                keyboard: false,
                backdrop: "static",
                onHide: function () {
                    angular.element("body").removeClass("modal-open").css("overflow", "auto");
                },
            });
        }

        function fetchAvailableResources(agentData, isCreate) {
            $scope.API.isProcessing = true;

            $q.all([$scope.API.getVoices(), $scope.API.getPrompts()])
                .then(
                    (values) => {
                        $scope.availableVoices = values[0].data;
                        $scope.availablePrompts = values[1].data;

                        $scope.agentObj.agent_name = agentData.agent_name;
                        $scope.agentObj.agent_id = agentData.agent_id;
                        $scope.agentObj.backup_human_phone_number = agentData.backup_human_phone_number;
                        $scope.agentObj.voice_id = agentData.voice_id;
                        $scope.agentObj.prompt_id_list = agentData.prompt_id_list || [];

                        $scope.agentObj.voice_obj = $scope.availableVoices.find((t) => t.voice_id === $scope.agentObj.voice_id);

                        if ($scope.agentObj.prompt_id_list && $scope.agentObj.prompt_id_list.length > 0) {
                            $scope.selection.promptId = $scope.agentObj.prompt_id_list[0];
                        } else {
                            $scope.selection.promptId = null;
                        }

                        $scope.showEdit = true;

                        if (isCreate) {
                            setTimeout(() => {
                                setupOnboard();
                            }, 2500);
                        }
                    },
                    (error) => showGenericErrorModal()
                )
                .catch(error => {
                    console.error("Error during resource fetching:", error && error.message);
                    $scope.API.isProcessing = false;
                    $scope.goBack();
                })
                .then(() => {
                    $scope.API.isProcessing = false;
                });
        }

        $scope.editAgent = (item) => {
            $scope.selection.promptId = null;
            $scope.testCall.phoneNumber = Session.user.phoneNumber || Session.user.phone_number || "";
            fetchAvailableResources(item, false);
        }

        const audio = document.getElementById("audioPlayer");

        $scope.togglePlay = function () {
            if ($scope.isPlaying) {
                audio.pause();
                $scope.isPlaying = false;
            } else {
                audio.play();
                $scope.isPlaying = true;
            }
        };

        audio.addEventListener("ended", function () {
            $scope.$apply(() => {
                $scope.isPlaying = false;
            });
        });

        $scope.onVoiceChange = () => {
            if ($scope.agentObj.voice_obj) {
                $scope.audioSrc = $scope.agentObj.voice_obj.preview_url
                $scope.isPlaying = false;
            }
        }

        $scope.navigate = (prompt) => {
            $scope.$ctrl.navigatePrompt({ prompt: prompt });
        }

        $scope.editSelectedTask = () => {
            const selectedPrompt = $scope.availablePrompts.find(p => p.prompt_id === $scope.selection.promptId);
            if (selectedPrompt) {
                $scope.navigate(selectedPrompt);
            }
        }

        $scope.goBack = () => {
            $scope.showEdit = false;
        }

        $scope.saveOrEditAIAgent = () => {
            if (!$scope.agentObj.voice_obj) {
                alert("Please select a voice.");
                return;
            }

            if (!$scope.agentObj.backup_human_phone_number || $scope.agentObj.backup_human_phone_number.length === 0) {
                alert("The Redirect Phone Number is required.");
                return;
            }

            const data = {
                practice_id: Session.practice.id,
                agent_name: $scope.agentObj.agent_name,
                backup_human_phone_number: $scope.agentObj.backup_human_phone_number,
                voice_id: $scope.agentObj.voice_obj.voice_id,
                voice_name: $scope.agentObj.voice_obj.name,
                prompt_id_list: $scope.selection.promptId ? [$scope.selection.promptId] : [],
            };

            $scope.API.isProcessing = true;
            let api = $scope.agentObj.agent_id ? $scope.API.updateAgent($scope.agentObj.agent_id, data) : $scope.API.createAgent(data);
            api.then(
                (resp) => {
                    $scope.goBack();
                    fetchAgentList();
                },
                (error) => showGenericErrorModal()
            ).then(() => {
                $scope.API.isProcessing = false;
            });
        }

        $scope.createAgent = () => {
            $scope.agentObj = {
                agent_name: '',
                prompt_id_list: [],
                backup_human_phone_number: Session.practice.phoneNumber,
            }
            $scope.selection = {
                promptId: null
            };
            $scope.testCall.phoneNumber = Session.user.phoneNumber || Session.user.phone_number || "";

            fetchAvailableResources($scope.agentObj, true);
        }

        function fetchAgentList() {
            $scope.API.isProcessing = true;

            $q.all([$scope.API.getAgents(), $scope.API.getPrompts()]).then(
                (values) => {
                    const activeAgents = values[0].data.filter(t => t.is_active);
                    const allPrompts = values[1].data;

                    activeAgents.forEach(agent => {
                        if (agent.prompt_id_list && agent.prompt_id_list.length > 0) {
                            const promptId = agent.prompt_id_list[0];
                            const matchedPrompt = allPrompts.find(p => p.prompt_id === promptId);

                            agent.agent_task = matchedPrompt ? matchedPrompt.name : 'Unknown Task';
                        } else {
                            agent.agent_task = 'No Task Assigned';
                        }
                    });

                    $scope.agentItems = activeAgents;
                },
                (error) => showGenericErrorModal()
            ).then(() => {
                $scope.API.isProcessing = false;
            });
        }

        function deleteAgent(item, deleteOrphans) {
            $scope.API.isProcessing = true;
            $scope.API.deleteAgent(item.agent_id, deleteOrphans).then(
                (resp) => {
                    fetchAgentList();
                },
                (error) => showGenericErrorModal()
            ).then(() => {
                $scope.API.isProcessing = false;
            })
        }

        $scope.onGeneralClick = function () {
            if ($scope.generalModal) {
                $scope.generalModal.hide();
            }
        }

        $scope.triggerTestCall = () => {
            const selectedPrompt = $scope.availablePrompts.find(p => p.prompt_id === $scope.selection.promptId);

            if (!selectedPrompt) return;

            const data = {
                practice_id: Session.practice.id,
                agent_id: $scope.agentObj.agent_id,
                prompt_id: selectedPrompt.prompt_id,
                date_scheduled_utc: null,
                patient_id: null,
                recipient_phone_number: $scope.testCall.phoneNumber || Session.user.phoneNumber,
                recipient_name: Session.user.firstName + " " + Session.user.lastName,
            };

            scheduleTestCall(data);
        }

        function setupOnboard() {
            if (!ELEVEN_LABS_AI_TOUR_1261) {
                return;
            }
            introJs
                .tour()
                .setOptions({
                    steps: [
                        {
                            title: 'Add agent name',
                            element: document.getElementById("agent_name"),
                            intro: "This step focuses on an element",
                        },
                        {
                            title: 'Select phone',
                            element: document.getElementById("phone_selector"),
                            intro: "This step focuses on an element",
                        },
                        {
                            title: 'Select and play voice',
                            element: document.getElementById("voice_selector"),
                            intro: "This step focuses on an element",
                        },
                        {
                            title: 'Select task',
                            element: document.getElementById("prompt_list_selector"),
                            intro: "This step focuses on an element",
                        },
                    ],
                    tooltipClass: "intro-customTooltip",
                    dontShowAgain: true,
                    showBullets: false
                })
                .start();
        }

        // Popover text for the new button
        $scope.popoverTestCall = {
            content: "Test Call",
        };

        $scope.openTestCallModal = (item) => {
            // Save the specific agent being tested
            $scope.currentTestAgent = item;

            // Bind a fresh phone number variable specifically for this modal 
            // to prevent overwriting the edit page's model accidentally
            $scope.testCallModalPhone = Session.user.phoneNumber || Session.user.phone_number || "";

            $scope.testCallModal = $modal({
                scope: $scope,
                templateUrl: "app/src/views/templates/modal.aiagents-test-call.tpl.html",
                show: true,
                backdrop: true,
                keyboard: false
            });
        };

        // Implemented Cancel Button
        $scope.onNegativeButtonClick = () => {
            if ($scope.testCallModal) {
                $scope.testCallModal.hide();
            }
        };

        // Dedicated submit function for the Modal
        $scope.submitTestCallModal = () => {
            if (!$scope.currentTestAgent || !$scope.currentTestAgent.prompt_id_list || $scope.currentTestAgent.prompt_id_list.length === 0) return;

            const data = {
                practice_id: Session.practice.id,
                agent_id: $scope.currentTestAgent.agent_id,
                prompt_id: $scope.currentTestAgent.prompt_id_list[0], // Grab the agent's actual prompt
                date_scheduled_utc: null,
                patient_id: null,
                recipient_phone_number: readModalPhone() || Session.user.phoneNumber,
                recipient_name: Session.user.firstName + " " + Session.user.lastName,
            };

            if ($scope.testCallModal) {
                $scope.testCallModal.hide();
            }

            scheduleTestCall(data);
        };

        // The modal's input binds a primitive on the modal's own child scope, so the number the user
        // typed lives there rather than on this scope.
        function readModalPhone() {
            const modalScope = $scope.testCallModal && $scope.testCallModal.$scope;
            return modalScope ? modalScope.testCallModalPhone : $scope.testCallModalPhone;
        }

        // Only tell the user a call is coming once the API has accepted it.
        function scheduleTestCall(data) {
            $scope.API.isProcessing = true;
            $scope.API.createOutboundCall(data)
                .then(
                    () => {
                        $scope.generalModal = $modal({
                            scope: $scope,
                            templateUrl: "app/src/views/templates/modal.general.tpl.html",
                            show: true,
                            title: "Test call scheduled",
                            content: 'A call with the agent has been scheduled. The agent will call within two minutes.',
                            backdrop: true,
                            keyboard: false,
                        });
                    },
                    () => showGenericErrorModal()
                )
                .then(() => {
                    $scope.API.isProcessing = false;
                });
        }
    },
]);